// extracted by mini-css-extract-plugin
module.exports = {"viewport":"SliderTrack_viewport__JGFJC","track":"SliderTrack_track__OCYeW","slide":"SliderTrack_slide__d438w","text":"SliderTrack_text__GNDh2"};